import { el } from 'redom';

class ContactResultRow {

  constructor() {

    this.data = null;

    this.profilePicture = el('.contact-profile-picture');
    this.fullName = el('.contact-full-name');
    this.email = el('.contact-email');

    this.textContainer = el('.contact-text-container', [
      this.fullName,
      this.email
    ]);

    this.el = el('.contact-result-row', [
      this.profilePicture,
      this.textContainer
    ]);

  }

  update(result) {

    this.data = result.data;

    this.fullName.textContent = this.data.fullName || '';
    this.email.textContent = this.data.email || '';

    const profilePictureURL = this.data.profilePicture?.url || '';

    this.profilePicture.style.backgroundImage = `url(${profilePictureURL})`;

  }

}

export default ContactResultRow;